import { API_END_POINT } from "config";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";

let connection = null;

export const startNotificationConnection = (onNotification, onNotificationViewed) => {
  connection = new HubConnectionBuilder()
    .withUrl(`${API_END_POINT}hubs/notifications`, {
        accessTokenFactory: () => {
            const token = localStorage.getItem("token");
            console.log("🔑 Using token:", token);
            return token;
          }
        })
    .configureLogging(LogLevel.Information)
    .withAutomaticReconnect()
    .build();

  connection.start()
    .then(() => console.log("✅ SignalR connected"))
    .catch(err => console.error("SignalR connection error:", err));

  connection.on("ReceiveNotification", (notification) => {
    console.log("🔔 Received notification:", notification);
    if (onNotification) onNotification(notification);
  });

  connection.on("NotificationViewed", (event) => {
    console.log("👀 Notification viewed:", event);
    if (onNotificationViewed) onNotificationViewed(event);
  });
};

export const stopNotificationConnection = () => {
  if (connection) {
    connection.stop();
    console.log("🔌 SignalR connection stopped");
  }
};
